<template>
  <div class="form-elements">
    <div class="row">
      <div class="flex lg12">
        <sp-360-panel :title="'management.iframes.form.manage-units' | translate">
          <div data-vv-scope="formIframe">
            <div class="row">
              <div class="flex lg12" style="margin-top:56px;">
                <fieldset>
                  <div class="form-group" :class="{ 'has-error': errors.has('management.iframes.form.nome') }">
                    <div class="input-group">
                      <va-input id="nome" name="nome" required v-model="iframe.nome" v-validate="'required'" label="Nome"/>
                      <!-- 'management.units.name' -->
                    </div>

                  </div>
                  <div class="form-group" :class="{ 'has-error': errors.has('management.iframes.form.link') }">
                    <div class="input-group">
                      <va-input id="link" name="link" required v-model="iframe.url" v-validate="'required'" label="URL"/>
                      <!-- 'management.units.initials' -->
                    </div>
                  </div>
                  <div class="form-group" :class="{ 'has-error': errors.has('management.iframes.form.titulo') }">
                    <div class="input-group">
                      <va-input id="titulo" name="titulo" v-model="iframe.titulo" label="Título"/>
                    </div>
                  </div>
                  <div class="form-group" :class="{ 'has-error': errors.has('management.iframes.form.rodape') }">
                    <div class="input-group">
                      <va-input id="rodape" name="rodape" v-model="iframe.rodapeComplementar" label="Rodapé"/>
                    </div>
                  </div>
                  <div class="form-group" :class="{ 'has-error': errors.has('management.iframes.form.nomeFonte') }">
                    <div class="input-group">
                      <va-input id="nomeFonte" name="nomeFonte" v-model="iframe.nomeFonte" label="Fonte dos Dados"/>
                    </div>
                  </div>
                  <div class="form-group" :class="{ 'has-error': errors.has('management.iframes.form.conteudoTooltip') }">
                    <div class="input-group">
                      <va-input id="conteudoTooltip" name="conteudoTooltip" v-model="iframe.conteudoTooltip" label="Conteúdo do Tooltip"/>
                    </div>
                  </div>
                  <div class="form-group" :class="{ 'has-error': errors.has('management.iframes.form.posicaoTooltip') }">
                    <div class="input-group">
                      <va-input id="posicaoTooltip" name="posicaoTooltip" v-model="iframe.posicaoTooltip" label="Posição do Tooltip"/>
                    </div>
                  </div>
                  <div class="form-group" :class="{ 'has-error': errors.has('management.iframes.form.integracao') }">
                    <div class="input-group">
                      <va-input id="integracao" name="integracao" required v-model="iframe.tipoIntegracao" v-validate="'required'" label="Tipo de Integração"/>
                      <!-- 'management.units.initials' -->
                    </div>
                  </div>
                  <div class="form-group" :class="{ 'has-error': errors.has('management.iframes.form.privilegio') }">
                    <div class="input-group">
                      <!-- <va-input id="privilegio" name="privilegio" required v-model="iframe.privilegio" v-validate="'required'" label="Sigla"/> -->
                      <!-- 'management.units.initials' -->
                      <multiselect
                        id="listaPrivilegios"
                        name="privilegios"
                        v-validate="'required'"
                        :placeholder="'management.profiles.privileges' | translate"
                        :options="listaPrivilegios"
                        label="nome"
                        track-by="nome"
                        v-model="iframe.privilegio"
                        open-direction="bottom"
                        :multiple="false"
                        :close-on-select="true"
                      />
                    </div>
                  </div>
                  <div class="form-group" :class="{ 'has-error': errors.has('management.iframes.form.autenticacao') }">
                    <div class="input-group">
                      <!-- <va-input id="privilegio" name="privilegio" required v-model="iframe.privilegio" v-validate="'required'" label="Sigla"/> -->
                      <!-- 'management.units.initials' -->
                      <multiselect
                        id="listaAutenticacoes"
                        name="autenticacoes"
                        v-validate="'required'"
                        :placeholder="'management.iframes.autenticacao.autenticacoes' | translate"
                        :options="listaAutenticacoes"
                        label="nomeAutenticacao"
                        track-by="nomeAutenticacao"
                        v-model="iframe.iframeAutenticacao"
                        open-direction="bottom"
                        :multiple="false"
                        :close-on-select="true"
                      />
                    </div>
                  </div>
                  <div class="flex lg12 md12 sm12" style="margin-top:1rem;">
                    <fieldset>
                      <h1 class="form-label">{{$t('management.iframes.form.tituloIntegracao')}}</h1>
                      <div class="row">
                        <div class="flex lg12">
                            <va-button type="button" @click="reverter()" class="btn btn-primary btn-sm pull-right">
                              {{'management.revertChanges'| translate}}
                            </va-button>
                        </div>
                      </div>
                  </fieldset>
                  <v-jsoneditor v-model="dadosIntegracao" :options="options" :plus="false" height="400px" @error="onError"/>
                </div>
                  <div class="row">
                    <div class="flex lg6">
                      <va-button type="button" @click="limpar()" class="btn btn-primary btn-sm pull-left">
                        {{'management.clear'| translate}}
                      </va-button>
                    </div>
                    <div class="flex lg6">
                      <va-button type="button" @click="persiste()" class="btn btn-primary btn-sm pull-right">
                        {{'management.save'| translate}}
                      </va-button>
                    </div>
                  </div>
                </fieldset>
              </div>

              <div class="flex lg12">
                  <va-input class="filter-input"
                    v-model="termo"
                    placeholder="Pesquisar"
                    removable
                    @input="pesquisa"
                  >
                    <va-icon name="fa fa-search" slot="prepend" />
                  </va-input>

                  <sp360-dataTable id="tabelaIframe" ref="tabelaIframe"
                    :apiMode="false"
                    :data="tabela.data"
                    :fields="tabela.campos"
                    :dataModeFilterableFields="tabela.filtros"
                    :sortFunctions="tabela.sort"
                    :perPage="tabela.itemsPerPage"
                    :filterInputShown="true"
                    @editarRow="editar($event)"
                    @deletarRow="deletarModal($event)"
                    :row-class="onRowClass"
                  />
              </div>
            </div>

          </div>
        </sp-360-panel>
      </div>
    </div>
    <div class="row">
      <div class="flex lg12">
        <sp-360-panel :title="'management.iframes.autenticacao.form.titulo' | translate">
          <div data-vv-scope="formIframeAuth">
            <div class="row">
              <div class="flex lg12" style="margin-top:56px;">
                <fieldset>
                  <div class="form-group" :class="{ 'has-error': errors.has('management.iframes.autenticacao.form.nomeAutenticacao') }">
                    <div class="input-group">
                      <va-input id="nomeAutenticacao" name="nomeAutenticacao" required v-model="autenticacao.nomeAutenticacao" v-validate="'required'" label="Nome"/>
                      <!-- 'management.units.name' -->
                    </div>
                  </div>
                  <div class="flex lg12 md12 sm12" style="margin-top:1rem;">
                    <fieldset>
                      <h1 class="form-label">{{$t('management.iframes.form.tituloIntegracao')}}</h1>
                      <div class="row">
                        <div class="flex lg12">
                            <va-button type="button" @click="reverterAuth()" class="btn btn-primary btn-sm pull-right">
                              {{'management.revertChanges'| translate}}
                            </va-button>
                        </div>
                      </div>
                  </fieldset>
                  <v-jsoneditor v-model="dadosAutenticacao" :options="optionsAuth" :plus="false" height="400px" @error="onError"/>
                </div>
                  <div class="row">
                    <div class="flex lg6">
                      <va-button type="button" @click="limparAuth()" class="btn btn-primary btn-sm pull-left">
                        {{'management.clear'| translate}}
                      </va-button>
                    </div>
                    <div class="flex lg6">
                      <va-button type="button" @click="persisteAuth()" class="btn btn-primary btn-sm pull-right">
                        {{'management.save'| translate}}
                      </va-button>
                    </div>
                  </div>
                </fieldset>
              </div>

              <div class="flex lg12">
                  <va-input class="filter-input"
                    v-model="termoAuth"
                    placeholder="Pesquisar"
                    removable
                    @input="pesquisaAuth"
                  >
                    <va-icon name="fa fa-search" slot="prepend" />
                  </va-input>

                  <sp360-dataTable id="tabelaIframeAuth" ref="tabelaIframeAuth"
                    :apiMode="false"
                    :data="tabelaAuth.data"
                    :fields="tabelaAuth.campos"
                    :dataModeFilterableFields="tabelaAuth.filtros"
                    :sortFunctions="tabelaAuth.sort"
                    :perPage="tabelaAuth.itemsPerPage"
                    :filterInputShown="true"
                    @editarRow="editarAuth($event)"
                    @deletarRow="deletarAuthModal($event)"
                    :row-class="onRowClass"
                  />
              </div>
            </div>

          </div>
        </sp-360-panel>
      </div>
    </div>
    <va-modal ref="iframeDelModal"
                   :okText="'management.delete' | translate"
                   :cancelText="'management.cancel' | translate"
                   :okClass="'btn btn-primary btn-sm'"
                   :cancelClass="'btn btn-secondary btn-sm'"
                   @ok="deletar()"
                   @cancel="cancelarDelecao()"
                   :title="'management.confirmation' | translate"
                   v-model="openModalDelecao"
                   >
      <template slot="default">
        {{'management.iframes.form.confirmacaoRemocao' | translate}}
      </template>
    </va-modal>
    <va-modal ref="authDelModal"
                   :okText="'management.delete' | translate"
                   :cancelText="'management.cancel' | translate"
                   :okClass="'btn btn-primary btn-sm'"
                   :cancelClass="'btn btn-secondary btn-sm'"
                   @ok="deletarAuth()"
                   @cancel="cancelarDelecaoAuth()"
                   :title="'management.confirmation' | translate"
                   v-model="openModalDelecaoAuth"
                   >
      <template slot="default">
        {{'management.iframes.autenticacao.form.confirmacaoRemocao' | translate}}
      </template>
    </va-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import Multiselect from 'vue-multiselect'
import UnidadeService from '@/services/UnidadeService'
import IframeService from '@/services/IframeDashboardService'
import constantes from '@/utils/ConstantesGlobais'
import MetodosGlobais from '@/utils/MetodosGlobais'
import Sp360DataTable from '@/components/ui/dataTable/sp360datatable'
import Sp360Panel from '@/components/ui/sp360-panel/sp360-panel'
import VJsoneditor from 'v-jsoneditor/src/index'

export default {
  components: { Multiselect, 
                'sp360-dataTable': Sp360DataTable, 
                Sp360Panel, 
                VJsoneditor },

  data () {
    return {
      openModalDelecao: false,
      termo: null,
      termoAuth: null,
      listaPrivilegios: [],
      listaAutenticacoes: [],
      tabela: {
        data: [],
        campos: [{
          name: 'nome',
          sortField: 'nome',
          title: 'Nome Interno',
          width: '25%',
        },
        {
          name: 'url',
          sortField: 'url',
          title: 'URL Externa',
          width: '25%',
        },
        {
          name: 'tipoIntegracao',
          sortField: 'tipoIntegracao',
          title: 'Tipo de Integração',
          width: '20%',
        },
        {
          name: 'privilegio.nome',
          sortField: 'privilegio.nome',
          title: 'Privilegio Associado',
          width: '20%',
        },
        {
          name: '__slot:edicao',
          dataClass: 'action-slot',
          width: '5%',
        },
        {
          name: '__slot:delecao',
          dataClass: 'action-slot',
          width: '5%',
        }],
        sort: {},
        filtro: ['nome'],
        itemsPerPage: 10,
      },
      tabelaAuth: {
        data: [],
        campos: [{
          name: 'nomeAutenticacao',
          sortField: 'nomeAutenticacao',
          title: 'Nome Interno',
          width: '30%',
        },
        {
          name: 'dadosAutenticacao',
          sortField: 'dadosAutenticacao',
          title: 'Dados Autenticação',
          width: '60%',
        },
        {
          name: '__slot:edicao',
          dataClass: 'action-slot',
          width: '5%',
        },
        {
          name: '__slot:delecao',
          dataClass: 'action-slot',
          width: '5%',
        }],
        sort: {},
        filtro: ['nomeAutenticacao'],
        itemsPerPage: 10,
      },
      iframe: IframeService.newIframe(),
      iframes: [],
      linkSel: {},
      iframeIntegrationHasErrors: true,
      iframeAutenticacaoHasErrors: true,
      options: {
        onValidationError: function (errors) {
          this.setStatus(errors)
        }.bind(this),
        modes: ['tree', 'code'],
        languages: constantes.JSONEDITOR_LOCALIZACAO
      },
      optionsAuth: {
        onValidationError: function (errors) {
          this.setStatusAuth(errors)
        }.bind(this),
        modes: ['tree', 'code'],
        languages: constantes.JSONEDITOR_LOCALIZACAO
      },
      openModalDelecaoAuth: false,
      dadosIntegracao: {},
      autenticacao: IframeService.newAutenticacao(),
      dadosIntegracaoInicial: {},
      dadosAutenticacao: {},
      dadosAUtenticacaoInicial: {}
    }
  },

  created () {
    Promise.all([
      this.$store.dispatch('privilegio/getAllPrivilegio'),
      this.$store.dispatch('iframeDashboard/getAllIframes'),
      this.$store.dispatch('iframeDashboard/getAllIframesAuth'),
    ])
      .then(
        retorno => {
          this.iframes = this.normalizarDados(retorno[1].data)
          this.tabela.data = this.iframes
          this.listaPrivilegios = retorno[0].data
          this.listaAutenticacoes = retorno[2].data
          this.tabelaAuth.data = this.listaAutenticacoes
          this.updateTabela(this.tabela.data)
          this.updateTabelaAuth(this.listaAutenticacoes)
        }
      )
  },
  computed: {
    toastLongDurationErrorConfig () {
      let toastConfig = constantes.TOASTED_ERROR
      toastConfig.duration = 5000
      return toastConfig
    },
  },
  methods: {
    cancelarDelecao () {
      this.iframeADeletar = {}
    },
    cancelarDelecaoAuth () {
      this.authADeletar = {}
    },

    onRowClass(dataItem, index) {
      return 'quebra-palavra'
    },

    normalizaIframe (iframe) {
      if(typeof iframe['tipoIntegracao'] === 'undefined' || iframe.tipoIntegracao === null)
        iframe['tipoIntegracao'] = "ACESSO_PUBLICO"

      if(typeof iframe['dadosIntegracao'] === 'undefined' || iframe.dadosIntegracao === null)
        iframe['dadosIntegracao'] = "{}"

      if(typeof iframe['iframeAutenticacao'] === 'undefined' || iframe.iframeAutenticacao === null)
        iframe['iframeAutenticacao'] = {nomeAutenticacao: '', dadosAutenticacao: {}}
      return iframe;
    },

    normalizarDados (iframes) {
      iframes.forEach(iframe => {
         this.normalizaIframe(iframe)
      })
      return iframes
    },

    pesquisa: _.debounce(function (term) {
      this.termo = term
      let itens_filtrados = []
      
      if ((!Number.isNaN(parseInt(term))) && term !== '') {
        itens_filtrados = this.$refs.tabelaIframe.filterByNumber(this.iframes, this.termo)
      } else {
        itens_filtrados = this.$refs.tabelaIframe.filterByString(this.iframes, this.termo)
      }

      this.tabela.data = itens_filtrados
      this.updateTabela(this.tabela.data)
    }, 400),

    pesquisaAuth: _.debounce(function (term) {
      this.termoAuth = term
      let itens_filtrados = []
      
      if ((!Number.isNaN(parseInt(term))) && term !== '') {
        itens_filtrados = this.$refs.tabelaIframeAuth.filterByNumber(this.listaAutenticacoes, this.termoAuth)
      } else {
        itens_filtrados = this.$refs.tabelaIframeAuth.filterByString(this.listaAutenticacoes, this.termoAuth)
      }

      this.tabelaAuth.data = itens_filtrados
      this.updateTabelaAuth(this.tabelaAuth.data)
    }, 400),

    valida () {
      return this.$validator.validateAll('formIframe').then(valid => {
        return valid
      })
    },

    validaAutenticacao () {
      return this.$validator.validateAll('formIframeAuth').then(valid => {
        return valid
      })
    },

    onError (error) {
    },

    setStatus (errors) {
      if (errors.length > 0) { this.iframeIntegrationHasErrors = true } else { this.iframeIntegrationHasErrors = false }
    },

    setStatusAuth (errors) {
      if (errors.length > 0) { this.iframeAutenticacaoHasErrors = true } else { this.iframeAutenticacaoHasErrors = false }
    },

    persiste () {
      event.preventDefault()
      this.valida().then(valido => {
        if (!valido) {
          this.showToast(this.$t('management.incorrectFields'), toastLongDurationErrorConfig)
        } else {
          if (this.iframeIntegrationHasErrors) {
            this.showToast(this.$t('management.localization.invalidJson'), constantes.TOASTED_ERROR)
          }
          else if (this.iframe.id === 0) {
            this.iframe.dadosIntegracao = JSON.stringify(this.dadosIntegracao)
            this.$store.dispatch('iframeDashboard/postIframeRetornar', this.iframe)
              .then(retorno => {
                this.showToast(this.$t('management.iframes.iframe') + ` ${retorno.data.nome}` + this.$t('management.inserted'), constantes.TOASTED_SUCCESS) // Refatorar i18n suporta template string ex: 'xyz - {var}'
                this.limpar()
                this.tabela.data.push(this.normalizaIframe(retorno.data))
              })
              .catch(err => {
                console.error(err)
                this.showToast(this.$t('management.insertedError') + ": " + MetodosGlobais.gerarMensagemErroBackend(err), this.toastLongDurationErrorConfig)
              })
          } else {
            let index = _.findIndex(this.iframes, o => o.id === this.iframe.id)
            this.iframe.dadosIntegracao = JSON.stringify(this.dadosIntegracao)
            this.$store.dispatch('iframeDashboard/putIframe', this.iframe)
              .then(retorno => {
                this.updateLink(this.normalizaIframe(this.iframe), index)
                this.showToast(this.$t('management.iframes.iframe') + ` ${this.iframe.nome}` + this.$t('management.updated'), constantes.TOASTED_SUCCESS)
                this.limpar()
              })
              .catch(err => {
                console.error(err)
                this.showToast(this.$t('management.updatedError') + ": " + MetodosGlobais.gerarMensagemErroBackend(err), this.toastLongDurationErrorConfig)
              })
          }
        }
      })
    },

    persisteAuth () {
      event.preventDefault()
      this.validaAutenticacao().then(valido => {
        if (!valido) {
          this.showToast(this.$t('management.incorrectFields'), constantes.TOASTED_ERROR)
        } else {
          if (this.iframeAutenticacaoHasErrors) {
            this.showToast(this.$t('management.localization.invalidJson'), constantes.TOASTED_ERROR)
          }
          else if (this.autenticacao.id === 0) {
            this.autenticacao.dadosAutenticacao = JSON.stringify(this.dadosAutenticacao)
            this.$store.dispatch('iframeDashboard/postIframeAuthRetornar', this.autenticacao)
              .then(retorno => {
                this.showToast(this.$t('management.iframes.autenticacao.autenticacao') + ` ${retorno.data.nomeAutenticacao}` + this.$t('management.inserted'), constantes.TOASTED_SUCCESS) // Refatorar i18n suporta template string ex: 'xyz - {var}'
                this.limparAuth()
                this.tabelaAuth.data.push(retorno.data)
              })
              .catch(err => {
                console.error(err)
                this.showToast(this.$t('management.insertedError') + ": " + MetodosGlobais.gerarMensagemErroBackend(err), this.toastLongDurationErrorConfig)
              })
          } else {
            let index = _.findIndex(this.listaAutenticacoes, o => o.id === this.autenticacao.id)
            this.autenticacao.dadosAutenticacao = JSON.stringify(this.dadosAutenticacao)
            this.$store.dispatch('iframeDashboard/putIframeAuth', this.autenticacao)
              .then(retorno => {
                this.updateAuth(this.autenticacao, index)
                this.showToast(this.$t('management.iframes.autenticacao.autenticacao') + ` ${this.autenticacao.nomeAutenticacao}` + this.$t('management.updated'), constantes.TOASTED_SUCCESS)
                this.limparAuth()
              })
              .catch(err => {
                console.error(err)
                this.showToast(this.$t('management.updatedError') + ": " + MetodosGlobais.gerarMensagemErroBackend(err), this.toastLongDurationErrorConfig)
              })
          }
        }
      })
    },

    updateLink (iframe, index) {
      Vue.set(this.tabela.data, index, iframe)
      this.$refs.tabelaIframe.resetPage()
    },

    updateAuth (autenticacao, index) {
      Vue.set(this.tabelaAuth.data, index, autenticacao)
      this.$refs.tabelaIframeAuth.resetPage()
    },

    editar (event) {
      let clone = _.cloneDeep(event.rowData)
      this.iframe = { 
        id: clone.id, 
        nome: clone.nome, 
        url: clone.url,
        titulo: clone.titulo,
        nomeFonte: clone.nomeFonte,
        rodapeComplementar: clone.rodapeComplementar,
        conteudoTooltip: clone.conteudoTooltip,
        posicaoTooltip: clone.posicaoTooltip,
        tipoIntegracao: clone.tipoIntegracao,
        privilegio:  _.find(this.listaPrivilegios, (e) => { return e.id === clone.privilegio.id }),
        iframeAutenticacao: _.find(this.listaAutenticacoes, (e) => { return e.id === clone.iframeAutenticacao.id }),
      }
        this.dadosIntegracao = JSON.parse(clone.dadosIntegracao)
        this.dadosIntegracaoInicial = JSON.parse(clone.dadosIntegracao)
    },

    editarAuth (event) {
      let clone = _.cloneDeep(event.rowData)
      this.autenticacao = { 
        id: clone.id, 
        nomeAutenticacao: clone.nomeAutenticacao, 
      }
        this.dadosAutenticacao = JSON.parse(clone.dadosAutenticacao)
        this.dadosAutenticacaoInicial = JSON.parse(clone.dadosAutenticacao)
    },

    deletarModal (event) {
      this.iframeADeletar = event.rowData
      this.openModalDelecao = true
    },
    deletarAuthModal (event) {
      this.authADeletar = event.rowData
      this.openModalDelecaoAuth = true
    },

    deletar () {
      this.$store.dispatch('iframeDashboard/deleteIframe', this.iframeADeletar.id)
        .then(
          retorno => {
            this.showToast(this.$t('management.iframe.forms.nome') + ` ${this.iframeADeletar.nome}` + this.$t('management.deleted'), constantes.TOASTED_SUCCESS)
            this.tabela.data = this.tabela.data.filter(uni => {
              return uni.id !== this.iframeADeletar.id
            })
          }
        )
        .catch(err => {
          console.error(err)
          this.showToast(this.$t('management.deletedError') + ": " + MetodosGlobais.gerarMensagemErroBackend(err), this.toastLongDurationErrorConfig)
        })
    },
    deletarAuth () {
      this.$store.dispatch('iframeDashboard/deleteIframeAuth', this.authADeletar.id)
        .then(
          retorno => {
            this.showToast(this.$t('management.iframe.forms.nome') + ` ${this.authADeletar.nomeAutenticacao}` + this.$t('management.deleted'), constantes.TOASTED_SUCCESS)
            this.tabelaAuth.data = this.tabelaAuth.data.filter(autenticacao => {
              return autenticacao.id !== this.authADeletar.id
            })
          }
        )
        .catch(err => {
          console.error(err)
          this.showToast(this.$t('management.deletedError') + ": " + MetodosGlobais.gerarMensagemErroBackend(err), this.toastLongDurationErrorConfig)
        })
    },

    limpar () {
      event.preventDefault()
      this.iframe = IframeService.newIframe()
      this.dadosIntegracao = {}
      this.dadosIntegracaoInicial = {}
      this.iframeIntegrationHasErrors = false
      this.$validator.reset()
    },

    limparAuth () {
      event.preventDefault()
      this.autenticacao = IframeService.newAutenticacao()
      this.dadosAutenticacao = {}
      this.dadosAutenticacaoInicial = {}
      this.iframeAutenticacaoHasErrors = false
      this.$validator.reset()
    },

    reverter () {
      this.dadosIntegracao = this.dadosIntegracaoInicial
    },

    reverterAuth () {
      this.dadosAutenticacao = this.dadosAutenticacaoInicial
    },

    updateTabela (dados) {
      this.$set(this.tabela, 'data', dados)
    },

    updateTabelaAuth (dados) {
      this.$set(this.tabelaAuth, 'data', dados)
    },
  },
}
</script>

<style>
.quebra-palavra {
  word-break: break-word;
}
</style>
